import { render } from "./EditBookingForm.vue?vue&type=template&id=c3248e32&scoped=true"
import script from "./EditBookingForm.vue?vue&type=script&lang=js"
export * from "./EditBookingForm.vue?vue&type=script&lang=js"

import "./EditBookingForm.vue?vue&type=style&index=0&id=c3248e32&scoped=true&lang=css"

import exportComponent from "/home/runner/work/LCAP/LCAP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3248e32"]])

export default __exports__